import type { Audience } from '@notes/sticky-notes-layout';
import { getLogicalRing } from 'owa-config';

export default function getAudience(): Audience | undefined {
    const logicalRing = getLogicalRing();
    let audience: Audience | undefined = undefined;
    switch (logicalRing) {
        case 'Dogfood':
            audience = 'Dogfood';
            break;
        case 'Microsoft':
            audience = 'Microsoft';
            break;
        case 'FirstRelease':
            audience = 'Insiders';
            break;
        case 'WW':
            audience = 'Production';
            break;
        default:
            break;
    }
    return audience;
}
